"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var in_dom_1 = require("./util/in-dom");
var style_1 = require("./style");
var has = Object.prototype.hasOwnProperty;
function getTransitionProperties() {
    var endEvent = '';
    var prefix = '';
    var transitions = {
        O: 'otransitionend',
        Moz: 'transitionend',
        Webkit: 'webkitTransitionEnd'
    };
    var element = document.createElement('div');
    for (var vendor in transitions) {
        if (has.call(transitions, vendor)) {
            if (element.style[vendor + 'TransitionProperty'] !== undefined) {
                prefix = '-' + vendor.toLowerCase() + '-';
                endEvent = transitions[vendor];
                break;
            }
        }
    }
    if (!endEvent && element.style.transitionProperty !== undefined) {
        endEvent = 'transitionend';
    }
    return { end: endEvent, prefix: prefix };
}
var transition = in_dom_1.inDOM ? getTransitionProperties() : undefined;
function transitionPrefix(property) {
    if (transition) {
        return transition.prefix + property;
    }
    return '';
}
exports.transitionProperties = {
    transform: transitionPrefix('transform') || 'transform',
    end: transition ? transition.end : '',
    property: transitionPrefix('transition-property'),
    timing: transitionPrefix('transition-timing-function'),
    delay: transitionPrefix('transition-delay'),
    duration: transitionPrefix('transition-duration')
};
function parseDuration(node) {
    var str = style_1.setStyle(node, exports.transitionProperties.duration || '');
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function end(node, handler, duration) {
    var fakeEvent = {
        target: node,
        currentTarget: node
    };
    var backup;
    function done(event) {
        if (event.target !== event.currentTarget) {
            return;
        }
        clearTimeout(backup);
        event.target.removeEventListener(exports.transitionProperties.end, done);
        handler.call(this);
    }
    if (!exports.transitionProperties.end) {
        duration = 0;
    }
    else if (duration == null) {
        duration = parseDuration(node) || 0;
    }
    if (exports.transitionProperties.end) {
        node.addEventListener(exports.transitionProperties.end, done, false);
        backup = setTimeout(function () { return done(fakeEvent); }, (duration || 100) * 1.5);
    }
    else {
        setTimeout(done.bind(null, fakeEvent), 0);
    }
}
exports.end = end;
end['_parseDuration'] = parseDuration;
